import styled from 'styled-components';
import { color, container, fontWeight, radius, screen, spacing } from 'theme';

export const StyledContainer = styled.div`
  max-width: ${container('xlMax')};
  margin: auto;
  padding: ${spacing('xl3')} ${spacing('md')} ${spacing('xl5')};
`;

export const StyledHeader = styled.div`
  max-width: ${container('lg')};
  margin: auto;
  text-align: center;

  p {
    margin-top: ${spacing('lg')};
    margin-bottom: ${spacing('xl')};
  }
`;

export const StyledFeatures = styled.div`
  margin-top: ${spacing('xl3')};
  display: grid;
  gap: ${spacing('mdlg')};
  grid-template-columns: minmax(0, 1fr);

  @media (min-width: ${screen('lg')}) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  }
`;

export const StyledCard = styled.div`
  background-color: ${color('midnight_900')};
  border-radius: ${radius('lg')};
  padding: 14px 14px 49px 14px;
  text-align: left;
  display: flex;
  max-width: 23rem;
  min-height: 34.5rem;
  justify-self: center;
`;

export const StyledCardInner = styled.div`
  background-image: linear-gradient(145deg, #850e53, #7b57e4);
  border-radius: 0.75rem 0.75rem 2rem 2rem;
  padding: 0.3125rem 0.625rem 0;
  display: flex;
`;

export const StyledCardContent = styled.div`
  filter: drop-shadow(-2px 2px 2.27px #261a19)
    drop-shadow(0px 2px 1.51px #261a19);
  display: flex;
  flex-direction: column;
  margin-bottom: -30px;
`;

export const StyledCardTitle = styled.h3`
  font-family: 'MTG', Papyrus, serif;
  margin: 0;
  font-size: 1.4375rem;
  line-height: 1;
  letter-spacing: 0.05em;
  padding: 7px 7px 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing('xs')};
  color: ${color('white')};
  background-image: linear-gradient(
    180deg,
    #15092f 0%,
    #736f81 13.02%,
    #686573 49.91%,
    #1d1439 88.54%,
    #1e076e 100%
  );
  border-radius: ${radius('md')};
  border: 2px solid ${color('midnight_100')};
  box-shadow: inset 0 0 0 1px ${color('midnight_700')};

  img {
    flex-shrink: 0;
  }
`;

export const StyledCardImage = styled.div`
  border: 3px solid ${color('midnight_100')};
  margin-left: 10px;
  margin-right: 10px;
  margin-top: -2px;

  img {
    display: block;
  }
`;

export const StyledCardMainContent = styled.div`
  background-color: ${color('midnight_100')};
  padding: 3px 3px 7px;
  border-radius: ${radius('md')} ${radius('md')} 0 0;
  margin-top: -1px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const StyledCardDesc = styled.p`
  background-color: ${color('midnight_150')};
  padding: ${spacing('xs')};
  border-radius: 6px;
  margin: 0;
  font-style: italic;
  font-weight: ${fontWeight('extraBold')};
  line-height: 1.125;
`;

export const StyledCardRewards = styled.div`
  flex-grow: 1;
  background-color: ${color('midnight_100')};
  box-shadow: inset -2px -2px 4px rgba(42, 42, 58, 0.15),
    inset 2px 2px 2px rgba(42, 42, 58, 0.25);
  padding: 10px 9px;
  margin-top: 7px;
  margin-left: 1px;
  margin-right: 1px;
  display: flex;
  flex-direction: column;
  gap: ${spacing('mdlg')};
`;

export const StyledCardReward = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${spacing('xs')};
  line-height: 1.25;
  font-weight: ${fontWeight('medium')};

  img {
    flex-shrink: 0;
  }
`;
